export default "<ngx-toasta [position]=\"'top-right'\"></ngx-toasta>\r\n<router-outlet></router-outlet>"